import React, { useEffect } from "react";
import linkifyHtml from "linkify-html";
import linkifyStr from "linkify-string";
import {
  Flex,
  Type,
  Divider,
  useMediaQuery,
} from "discover.medical.react-component-library";
import {
  StyledNoteWidget,
  StyledNoteContainer,
  StyledEditHistoryContainer,
  StyledNoteContentContainer,
} from "./_.styled";
import { contentNoteTestIds } from "../../constants/content-notes";

const ContentNote = ({ displayedContent, displayData }) => {
  const isRichText = /^(<p|<ul|<ol)/.test(displayedContent.trim());
  const maxLgMq = useMediaQuery("max", "lg");

  useEffect(() => {}, [displayData]);

  return (
    <StyledNoteWidget data-testid="content-note-wrapper">
      <StyledNoteContainer column={maxLgMq} container>
        <StyledEditHistoryContainer cell span={maxLgMq ? 12 : 3}>
          <Flex container column>
            <Type element="h6" data-testid={contentNoteTestIds.title}>
              {displayData.title}
            </Type>
            <Type
              element="p"
              data-testid={contentNoteTestIds.date}
              fontSize="sm"
              fontWeight="semibold"
            >
              {displayData.date}
            </Type>
          </Flex>
        </StyledEditHistoryContainer>
        <Divider vertical />
        <StyledNoteContentContainer
          cell
          span={maxLgMq ? 12 : 9}
          isRichText={isRichText}
        >
          <Flex cell>
            <Type data-testid={contentNoteTestIds.noteContent}>
              {isRichText ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: linkifyHtml(displayedContent, {
                      defaultProtocol: "https",
                      target: "_blank",
                      rel: "noopener noreferrer",
                    }),
                  }}
                />
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: linkifyStr(displayedContent, {
                      defaultProtocol: "https",
                      target: "_blank",
                      rel: "noopener noreferrer",
                    }),
                  }}
                />
              )}
            </Type>
          </Flex>
        </StyledNoteContentContainer>
      </StyledNoteContainer>
    </StyledNoteWidget>
  );
};

ContentNote.displayName = "NonAdminContentNote";

export default ContentNote;
